import TgAuth from './tgAuth';

export default TgAuth;
